import React from 'react';
import PropTypes from 'prop-types';
import { Quote } from '../../../quotes/quote';
import QuoteView from '../../../quotes/view/quoteView';
import { Button } from '@ami/react/core';
import { downloadWithFallback } from '@ami/react/core';
import { withRouter } from 'react-router-dom';
import { isUserAuthorizedToManageQuotesInDealerBranch } from '../../../authorization/permissions';
import { quoteReOpeningStatus } from '../quoteView';
import { appConfig } from '@ami/react/core';
import { isAmiUserAuthorizedToQuotePdfwithNoLeadTimes } from '../../../authorization/amiPermissions';
import {
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
  NavbarToggler,
} from 'reactstrap';

class QuoteHeaderComponent extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      downloadingPdf: false,
      downloadingMsrpOnlyPdf: false,
      subscribing: false,
      canManage: false,
      downloadingPdfWithNoLeadTimes: false,
    };
  }

  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    onCancel: PropTypes.func.isRequired,
    onExpire: PropTypes.func.isRequired,
    onDealerBranchChange: PropTypes.func.isRequired,
    onPriceZoneChange: PropTypes.func.isRequired,
    onReSendCreateNotification: PropTypes.func.isRequired,
    onAddCustomActivity: PropTypes.func.isRequired,
    onRequestNewLeadTime: PropTypes.func.isRequired,
    onCopyQuote: PropTypes.func.isRequired,
    onReOpen: PropTypes.func.isRequired,
    refreshQuote: PropTypes.func.isRequired,
    onUpdatePartNumbers: PropTypes.func.isRequired,
  };

  downloadAsPdf = async (quote) => {
    this.setState({ downloadingPdf: true });
    quote.downloadPdf().then((blob) => {
      downloadWithFallback(
        blob,
        `Quote-${quote.number}-${quote.revisionNumber}.pdf`
      );
      this.setState({ downloadingPdf: false });
    });
  };

  downloadAsMsrpOnlyPdf = async (quote) => {
    this.setState({ downloadingMsrpOnlyPdf: true });
    quote.downloadMsrpOnlyPdf().then((blob) => {
      downloadWithFallback(
        blob,
        `Quote-MSRP-${quote.number}-${quote.revisionNumber}.pdf`
      );
      this.setState({ downloadingMsrpOnlyPdf: false });
    });
  };

  downloadAsPdfWithNoLeadTimes = async (quote) => {
    this.setState({ downloadingPdfWithNoLeadTimes: true });
    quote.downloadAsPdfWithNoLeadTimes().then((blob) => {
      downloadWithFallback(
        blob,
        `Quote-NoLead-${quote.number}-${quote.revisionNumber}.pdf`
      );
      this.setState({ downloadingPdfWithNoLeadTimes: false });
    });
  };

  edit = () => {
    this.props.history.push(`/quotes/edit/${this.props.quote.id}/review`);
  };

  async componentDidMount() {
    const { dealerInformation } = this.props.quote;
    const canManage = isUserAuthorizedToManageQuotesInDealerBranch(
      dealerInformation.dealerGroupId,
      dealerInformation.dealerBranchId
    );
    this.setState({ canManage });
  }

  subscribe = async () => {
    this.setState({ subscribing: true });
    const { quote } = this.props;
    await Quote.subscribe(quote.id).then(() => {
      this.setState({ subscribing: false });
      this.props.refreshQuote();
    });
  };

  unsubscribe = async () => {
    this.setState({ subscribing: true });
    const { quote } = this.props;
    await Quote.unsubscribe(quote.id).then(() => {
      this.setState({ subscribing: false });
      this.props.refreshQuote();
    });
  };

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { quote } = this.props;
    const {
      downloadingPdf,
      downloadingMsrpOnlyPdf,
      canManage,
      subscribing,
      downloadingPdfWithNoLeadTimes,
    } = this.state;
    const { statusInformation } = quote;
    const canDownloadPdf = !statusInformation.isCancelled;
    const canDownloadPdfWithNoLeadTimes =
      isAmiUserAuthorizedToQuotePdfwithNoLeadTimes() && canDownloadPdf;
    return (
      <Navbar color="dark" dark expand="lg" className="quote-header">
        <div className="row">
          <div className="col-lg-5">
            <NavbarBrand>
              <h2 className="page-title">
                <div title={quote.name}>{quote.name}</div>
                <div className="subtitle">
                  Quote {quote.number} {`rev${quote.revisionNumber}`}
                </div>
              </h2>
            </NavbarBrand>
          </div>
          <div className="col-lg-7">
            <NavbarToggler onClick={this.toggle} className="" />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="quote-nav" navbar>
                <div className="row buttons-wrapper justify-content-end">
                  {canDownloadPdf && (
                    <NavItem>
                      <Button
                        label="PDF"
                        onClick={() => this.downloadAsPdf(quote)}
                        className="btn-primary w-100"
                        iconName="download"
                        showSpinner={downloadingPdf}
                        disabled={downloadingPdf}
                      />
                    </NavItem>
                  )}
                  {canDownloadPdf && (
                    <NavItem>
                      <Button
                        label="MSRP PDF"
                        onClick={() => this.downloadAsMsrpOnlyPdf(quote)}
                        className="btn-primary w-100"
                        iconName="download"
                        showSpinner={downloadingMsrpOnlyPdf}
                        disabled={downloadingMsrpOnlyPdf}
                      />
                    </NavItem>
                  )}
                  {canDownloadPdfWithNoLeadTimes && (
                    <NavItem>
                      <Button
                        label="No Lead PDF"
                        onClick={() => this.downloadAsPdfWithNoLeadTimes(quote)}
                        className="btn-primary w-100"
                        iconName="download"
                        showSpinner={downloadingPdfWithNoLeadTimes}
                        disabled={downloadingPdfWithNoLeadTimes}
                      />
                    </NavItem>
                  )}
                  {statusInformation.canSubscribeToChanges && (
                    <NavItem>
                      <Button
                        label={
                          subscribing
                            ? quote.isCurrentUserSubscribed
                              ? 'Unsubscribing'
                              : 'Subscribing'
                            : quote.isCurrentUserSubscribed
                            ? 'Unsubscribe'
                            : 'Subscribe'
                        }
                        onClick={() =>
                          quote.isCurrentUserSubscribed
                            ? this.unsubscribe()
                            : this.subscribe()
                        }
                        className="btn-primary w-100"
                        showSpinner={subscribing}
                        disabled={subscribing}
                      />
                    </NavItem>
                  )}
                  {appConfig.isManagementApp &&
                    !statusInformation.isExpired &&
                    !statusInformation.isCancelled && (
                      <NavItem>
                        <Button
                          label="Part Numbers"
                          onClick={this.props.onUpdatePartNumbers}
                          className="btn btn-primary w-100"
                        />
                      </NavItem>
                    )}
                  {appConfig.isManagementApp &&
                    canManage &&
                    statusInformation.isPending && (
                      <NavItem>
                        <Button
                          label="Expire"
                          onClick={this.props.onExpire}
                          className="btn btn-primary w-100"
                        />
                      </NavItem>
                    )}
                  {appConfig.isManagementApp && canManage && (
                    <NavItem>
                      <Button
                        label="Add Activity"
                        onClick={this.props.onAddCustomActivity}
                        className="btn btn-primary w-100"
                      />
                    </NavItem>
                  )}
                  {statusInformation.canBeCopied && canManage && (
                    <NavItem>
                      <Button
                        label="Copy"
                        onClick={this.props.onCopyQuote}
                        className="btn-primary w-100"
                      />
                    </NavItem>
                  )}
                  {statusInformation.canBeReOpened !==
                    quoteReOpeningStatus.forbidden && (
                    <NavItem>
                      <Button
                        label="Re-open"
                        onClick={() =>
                          this.props.onReOpen(statusInformation.canBeReOpened)
                        }
                        className="btn-primary w-100"
                      />
                    </NavItem>
                  )}
                  {statusInformation.canBeEdited && canManage && (
                    <NavItem>
                      <Button
                        label="Change Branch"
                        onClick={this.props.onDealerBranchChange}
                        className="btn-primary w-100"
                      />
                    </NavItem>
                  )}
                  {appConfig.isManagementApp &&
                    statusInformation.canBeEdited &&
                    canManage && (
                      <NavItem>
                        <Button
                          label="Change Zone"
                          onClick={this.props.onPriceZoneChange}
                          className="btn-primary w-100"
                        />
                      </NavItem>
                    )}
                  {appConfig.isManagementApp &&
                    !statusInformation.isExpired &&
                    !statusInformation.isCancelled &&
                    canManage && (
                      <NavItem>
                        <Button
                          label="Re-send"
                          onClick={this.props.onReSendCreateNotification}
                          className="btn-primary w-100"
                        />
                      </NavItem>
                    )}
                  {statusInformation.canBeEdited && canManage && (
                    <NavItem>
                      <Button
                        label="Edit"
                        onClick={this.edit}
                        className="btn-primary w-100"
                      />
                    </NavItem>
                  )}
                  {appConfig.isManagementApp && canManage && (
                    <NavItem>
                      <Button
                        label="Lead Time Request"
                        onClick={this.props.onRequestNewLeadTime}
                        className="btn btn-primary w-100"
                      />
                    </NavItem>
                  )}
                  {statusInformation.canQuoteBeCancelled && canManage && (
                    <NavItem>
                      <Button
                        label="Cancel"
                        onClick={this.props.onCancel}
                        className="btn-danger w-100"
                      />
                    </NavItem>
                  )}
                </div>
              </Nav>
            </Collapse>
          </div>
        </div>
      </Navbar>
    );
  }
}

export default withRouter(QuoteHeaderComponent);
